import { useEffect, useState } from "react";
import { pget } from "./portalApi";
import { Contact as ContactIcon, Phone, Search } from "lucide-react";

const fmtPhone = (raw) => {
  if (!raw) return "";
  let d = String(raw).replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return raw;
};

export default function PortalContacts() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pget("/resident/contacts").then((r) => setItems(r.data.items || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = items.filter((c) => `${c.title || ""} ${c.role || ""} ${c.phone || ""} ${c.description || ""}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6" data-testid="portal-contacts-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight flex items-center gap-2"><ContactIcon className="h-7 w-7 text-redline-500" strokeWidth={1.75} /> Trusted Pros</h1>
        <p className="text-muted-foreground mt-1">Who to call — your community&apos;s official directory. Or just text the concierge &ldquo;who do I call for…&rdquo;</p>
      </div>

      <div className="relative max-w-xs">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-sand-400" />
        <input data-testid="portal-contact-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, role or number"
          className="w-full rounded-full border border-sand-200 bg-white pl-10 pr-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-redline-500/30" />
      </div>

      {loading ? <div className="flex justify-center py-16"><div className="h-7 w-7 rounded-full border-2 border-redline-500 border-t-transparent animate-spin" /></div>
        : filtered.length === 0 ? <div className="bg-white rounded-2xl border border-sand-200 p-12 text-center text-muted-foreground">{q ? "No matches." : "No contacts shared yet."}</div>
        : <div className="grid gap-3 sm:grid-cols-2" data-testid="portal-contacts-list">
          {filtered.map((c) => (
            <div key={c.id} data-testid={`portal-contact-${c.id}`} className="bg-white rounded-2xl border border-sand-200 p-4">
              <div className="font-heading font-bold text-ink">{c.title}</div>
              {c.role && <div className="text-xs font-semibold text-redline-600 mt-0.5">{c.role}</div>}
              {c.description && <p className="text-sm text-ink-600 mt-1.5">{c.description}</p>}
              {c.phone && (
                <a data-testid={`portal-contact-call-${c.id}`} href={`tel:${c.phone}`}
                  className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-ink text-white text-sm font-semibold px-3.5 py-1.5 hover:bg-redline-500 transition-colors">
                  <Phone className="h-3.5 w-3.5" /> {fmtPhone(c.phone)}
                </a>
              )}
            </div>
          ))}
        </div>}
    </div>
  );
}
